export type TDvsErrorDetail = {
  field?: string;
  source?: string;
  message?: string;
};

export type TDvsStatusWithErrorDetails = {
  status?: keyof typeof TDocumentVerificationStatus;
  errorDetails?: TDvsErrorDetail[];
};

export type TDocumentVerificationStatusActions = Omit<
  typeof TDocumentVerificationStatus,
  'Pending' | 'SystemError'
>;

export enum TDocumentVerificationStatus {
  Pending = 'Pending',
  Passed = 'Passed',
  Failed = 'Failed',
  SystemError = 'SystemError',
  DataError = 'DataError',
  /**
   * The document is outside the scope of DVS's source check, typically a foreign document or an
   * unsupported type. Terminal and complete: it records that no source check was or ever will be
   * performed, which is not the same as one that has not run yet.
   *
   * Mirrors `DocumentVerificationStatus` in person-api. This enum is maintained by hand rather than
   * taken from the generated client, so it has to be widened here in step with the spec, and the
   * two must not be allowed to drift.
   *
   * Set by an administrator through the DVS status override in the admin portal, and set
   * automatically for a photo card when it is captured, because DVS has no source to check that
   * document against (verifime-adr#815).
   */
  NotApplicable = 'NotApplicable',
}
